export default "__VITE_ASSET__DS_yao0S__"